export const YearlyReport = () => import("./YearlyReport.vue");
export const BudgetSummary = () => import("./BudgetSummary.vue");
export const BudgetPreSanction = () => import("./PreSanction.vue");
export const Summary = () => import("./Summary.vue");
export const SummaryYearly = () => import("./SummaryYearly.vue");
